import { useSelector } from 'react-redux';
import { getGeoCoordinates } from '../../../selectors/newbuilding';
import { getYandexStaticMapsUrl } from '../../../utils/config/getYandexStaticMapUrl';
import { useApplicationContext } from '../../../utils/withApplicationContext';

export function useMapPreviewUrl(width: number, height: number) {
  const { config } = useApplicationContext();
  const yandexStaticMapsUrl = getYandexStaticMapsUrl(config);
  const coordinates = useSelector(getGeoCoordinates);

  if (coordinates) {
    const { lat, lng } = coordinates;

    return `${yandexStaticMapsUrl}?ll=${lng},${lat}&size=${width},${height}&z=16&l=map`;
  }

  return null;
}
